import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePageVisitsStore from '../stores/usePageVisitsStore';

/**
 * Hook para trackear automáticamente las visitas a páginas
 * @param {string} pageTitle - Título personalizado de la página (opcional)
 */
export const usePageTracking = (pageTitle = '') => {
  const location = useLocation();
  const visitPage = usePageVisitsStore((state) => state.visitPage);

  useEffect(() => {
    if (location.pathname !== '/' && location.pathname !== '/home') {
      const title = pageTitle || 
        location.pathname
          .split('/')
          .filter(Boolean)
          .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
          .join(' > ');
      
      visitPage(location.pathname, title);
    }
  }, [location.pathname, pageTitle, visitPage]);
};

/**
 * Hook para obtener las páginas más visitadas
 */
export const useMostVisitedPages = () => {
  const store = usePageVisitsStore();
  
  return {
    mostVisitedPages: store.getMostVisitedPages(),
    hasSufficientData: store.hasSufficientData(),
    totalPagesVisited: store.getTotalPagesVisited(),
    clearAllVisits: store.clearAllVisits,
    getPageStats: store.getPageStats,
  };
};
